import { NodeType } from '@amplify/amp-module';
import ButtonGroup from './ButtonGroup';
import Card from './Card';
import Carousel from './Carousel';
import Embed from './Embed.vue';
import GoTo from './GoTo.vue';
import InputField from './InputField.vue';
import Message from './Message';
import Open from './Open.vue';
import Player from './Player';
import Plugin from './Plugin.vue';
import Question from './Question';
import FormNode from './FormNode.vue';

export default {
  ['inputField']: InputField,
  [NodeType.buttonGroup]: ButtonGroup,
  [NodeType.carousel]: Carousel,
  [NodeType.embedded]: Embed,
  [NodeType.goTo]: GoTo,
  [NodeType.message]: Message,
  [NodeType.open]: Open,
  [NodeType.player]: Player,
  [NodeType.plugin]: Plugin,
  [NodeType.question]: Question,
  [`${NodeType.form}Node`]: FormNode,
  Card,
};
